<div class="bg-blue persona-container">
    <apc-navbar-big [items]=navigation></apc-navbar-big>
    <div class="content">
        <app-datatable [sortArray]="[{prop: 'updated', dir: 'desc'}]" [service]="projectsService.getProjects"
            [defaultColumns]="defaultColumns" [columnsToExclude]="columnsToExclude" [section]="'projects'">
        </app-datatable>
    </div>
</div>